/**
 * Created by Omar Alejandro Leonor Avalos on 2017-07-23.
 * Date Range
 *
 * Will, notify until range is complete
 */
import React, { Component } from 'react';
import { DatePicker } from 'material-ui';
import moment from 'moment';

class DateRange extends Component {

    constructor() {
        super();
        this.state = {
            start: null,
            end: null,
            date1: null,
            date2: null

        };
    }

    render() {
        const { start, end, date1, date2} = this.state;
        const { notify, searchTexts, searchTexts2 } = this.props;

        return (
            <div>
                <DatePicker
                    formatDate={(date) => moment(date).format('DD-MM-YYYY')}
                    autoOk
                    floatingLabelText="Fecha Min"
                    floatingLabelFixed
                    fullWidth
                    value={searchTexts}
                    onChange={(event, value) => {
                        //Notifies if end is not null
                        this.setState({ date1: value });
                        const selectedDate = moment(value).format('DD-MM-YYYY');
                        this.setState({ start: selectedDate });
                        notify(selectedDate, end, value, date2);
                    }}
                />
                <DatePicker
                    formatDate={(date) => moment(date).format('DD-MM-YYYY')}
                    autoOk
                    floatingLabelText="Fecha Max"
                    floatingLabelFixed
                    fullWidth
                    value={searchTexts2}
                    onChange={(event, value) => {
                        //Notifies if start is not null
                        this.setState({ date2: value });
                        const selectedDate = moment(value).format('DD-MM-YYYY');
                        this.setState({ end: selectedDate });
                        notify(start, selectedDate, date1, value);
                    }}
                />
            </div>
        );
    }
}

export default DateRange;



// WEBPACK FOOTER //
// ./components/filters/dateRange.js